import { axiosBitrixInstance } from "../../../utils/axios/requestInfo";
import { cleanPhone } from "../../../utils/form/phoneFormat";
import { api } from "../../../resources/api";

export interface BitrixPartnerLookupParams {
  phone?: string;
  partnerId?: string;
  birthday?: string;
  profileName?: string;
  skipPartnerIdCheck?: boolean;
}

export interface BitrixPartnerLookupResponse {
  partnerId: string | null;
}

export const bitrixPartnerLookup = async (
  params: BitrixPartnerLookupParams
): Promise<string | null> => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.phone) {
      const cleanedPhone = cleanPhone(params.phone);
      queryParams.append('phone', cleanedPhone);
    }
    if (params.partnerId) {
      queryParams.append('partnerId', params.partnerId);
    }
    if (params.birthday) {
      queryParams.append('birthday', params.birthday);
    }
    if (params.profileName) {
      queryParams.append('profileName', params.profileName);
    }

    const url = `${api.bitrix.PARTNER_LOOKUP}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

    const response = await axiosBitrixInstance.get<BitrixPartnerLookupResponse>(
      url,
      {
        skipPartnerIdCheck: params.skipPartnerIdCheck || false,
      } as any
    );

    return response.data.partnerId;
  } catch (error: any) {
    return null;
  }
};

